import React from 'react';
import './SectionHeader.css';

const SectionHeader = ({ title, isExpanded, onToggle, children }) => {
    return (
        <div className="section-header-container" onClick={onToggle}>
            <h2>{title}</h2>
            <div className="section-header-right">
                {children}
                {onToggle && (
                    <button
                        className="expand-button-chevron"
                        onClick={(e) => {
                            e.stopPropagation();
                            onToggle();
                        }}
                        aria-label={isExpanded ? 'Collapse' : 'Expand'}
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
                        >
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </button>
                )}
            </div>
        </div>
    );
};

export default SectionHeader;
